export default "__VITE_ASSET__a3F_WuB2__"